import CheckListIcon from '../../icons/CheckListIcon';
import NavigatorIcon from '../../icons/NavigatorIcon';
import BusinessVaultIcon from '../../icons/BusinessVaultIcon';
import PrimeServicesIcon from '../../icons/PrimeServicesIcon';
import MailIcon from '../../icons/MailIcon';
import TemplateIcon from '../../icons/TemplateIcon';
import ServiceDashboardIcon from '../../assets/other/serviceDashboard.png';
import AssessmentIcon from '../../icons/AssessmentIcon';

export const MAIN_SIZE = {
    mt: '54px',
    small_ml: '4.688rem',
    large_ml: '17.5rem',

    responsive_mt: '54px',
};
export const NAV_ITEMS_LIST = [
    // First part
    {
        title: 'Services Dashboard',
        path: '/',
        icon: <img src={ServiceDashboardIcon} alt="Service Dashboard" style={{ width: '16px', height: '16px' }} />,
        relatedTo: 'PRIME SERVICES',
    },
    {
        title: 'My Companies',
        path: '/my-companies',
        icon: <BusinessVaultIcon />,
        list: [
            {
                title: 'AJG Holdings, LLC',
                path: '/1',
            },
            {
                title: 'Sunrise Properties, LLC',
                path: '/2',
            },
        ],
        relatedTo: 'PRIME SERVICES',
    },
    {
        title: 'Payment Information',
        path: '/payment-information',
        icon: <PrimeServicesIcon />,
        list: [
            {
                title: 'Billing History',
                path: '/billing-history',
            },
            {
                title: 'Manage Payments',
                path: '/payment-methods',
            },
        ],
        relatedTo: 'PRIME SERVICES',
    },
    {
        title: 'Mailbox',
        path: '/mail',
        icon: <MailIcon />,
        relatedTo: 'PRIME SERVICES',
    },
    // {
    //     title: 'Estate Planning',
    //     path: '/estate-planning',
    //     icon: <MailIcon />,
    //     relatedTo: 'PRIME SERVICES',
    // },
    {
        title: 'Prime Assessment',
        path: '/prime-assessment-list',
        icon: <AssessmentIcon />,
        relatedTo: 'PRIME SERVICES',
        otherPaths: ['/prime-assessment'],
    },
    // Second part
    {
        title: 'My Business Checklist',
        path: '/my-business-checklist',
        icon: <CheckListIcon />,
        relatedTo: 'BUSINESS TOOLS',
    },
    {
        title: 'Business Navigator',
        path: '/business-navigator',
        icon: <NavigatorIcon />,
        relatedTo: 'BUSINESS TOOLS',
    },
    // {
    //     title: 'Legal Templates',
    //     path: '/legal-templates',
    //     icon: <TemplateIcon />,
    //     relatedTo: 'BUSINESS TOOLS',
    // },
];
